(function($, window, document, s, undefined) {

  // Helpers

  // Collects all ids from a set of jquery elements that have data attribute `data-id`
  $.fn.collectIds = function collectIds() {
    var exclude_ids = [];
    $(this).each(function(i, post) {
      var id = $(post).data('id');
      exclude_ids.push(id);
    });
    return exclude_ids;
  };

  // Collects duplicate elements of an array
  function compressArray(original) {
    var compressed = [];
    // make a copy of the input array
    var copy = original.slice(0);
    // first loop goes over every element
    for (var i = 0; i < original.length; i++) {
      var myCount = 0;
      // loop over every element in the copy and see if it's the same
      for (var w = 0; w < copy.length; w++) {
        if (original[i] == copy[w]) {
          // increase amount of times duplicate is found
          myCount++;
          // sets item to undefined
          delete copy[w];
        }
      }
      if (myCount > 0) {
        var a = {};
        a.value = original[i];
        a.count = myCount;
        compressed.push(a);
      }
    }
    return compressed;
  }

  // Deletes duplicate items from an array
  var unique = function(origArr) {
      var newArr = [],
          origLen = origArr.length,
          found, x, y;

      for (x = 0; x < origLen; x++) {
          found = undefined;
          for (y = 0; y < newArr.length; y++) {
              if (origArr[x] === newArr[y]) {
                  found = true;
                  break;
              }
          }
          if (!found) {
              newArr.push(origArr[x]);
          }
      }
      return newArr;
  };

  var setupSelectSubmit = function setupSelectSubmit() {
    $('#post-filters select').on('change', function(e) {
      $('#post-filters').first().submit();
    });
  };

  var setupLoadMore = function setupLoadMore() {
    var loadingInterval = function(){};
    var $load = $('#load-more');
    var $postList = $('#post-list');
    var $blogpost = $('.blogpost');

    // Default posts to load per ajax request
    var loadPerClick = 10;

    // Max loading dots
    var maxLoadingDots = 4;

    // Dot loading interval (ms)
    var dotLoadingInterval = 460;

    // Create an html prototype for post that will be replicated for each ajax result
    // Prototype will be based on the first post from the #post-list
    var $postPrototype = $blogpost.first().clone();

    // Initialize pagination indexes
    var start = parseInt(s.ajaxBlog.start, 10);
    var end = parseInt(s.ajaxBlog.end, 10);
    var cat_id = parseInt(s.ajaxBlog.cat_id, 10);
    var tag_id = parseInt(s.ajaxBlog.tag_id, 10);

    // Ids that will be excluded from ajax call
    var exclude_ids = $blogpost.collectIds();
    var exclude_ids_query = exclude_ids.join(',');

    // Move start pointer to the end of the posts
    start += end;

    // Dirty temporary env prefix fix
    var debug = Boolean(s.ajaxBlog.debug);
    var env_prefix = debug ? '' : '/~ikarosbooks';

    $load.on('click', function(e) {

      clearTimeout(loadingInterval);

      e.preventDefault();

      // Remove dots from previous loads
      $load.html($load.html().replace(/\./g, ''));

      // Add loading with dots effect
      loadingInterval = setInterval(function() {
        var numberOfDots = ($load.html().match(/\./g) || []).length;
        // Allow fixed number of dots and then restart
        if (numberOfDots > maxLoadingDots) {
          // Remove dots
          $load.html($load.html().replace(/\./g, ''));
        } else {
          // Append dots
          $load.append('.');
        }
      }, dotLoadingInterval);

      // Exclude posts query string that will be sent with ajax, TODO: currently innactive
      exclude_ids_query = exclude_ids.join(',');

      jQuery.ajax({
        url: s.ajaxBlog.url,
        data: {
          start: start,
          end: end,
          cat_id: cat_id,
          tag_id: tag_id,
          exclude_ids: exclude_ids_query,
        },
        success: function(data) {
          // Clear loading interval
          clearTimeout(loadingInterval);

          // If ajax query request returns posts
          if (data.wp_posts.length) {

            // Populate html
            _.each(data.wp_posts, function(post, index, list) {
              var $newPost = $postPrototype.clone();
              $newPost
                .attr('data-id', post.ID)
                .find('.link').attr('href', env_prefix+'/blog/'+post.slug)
                .end()
                .find('.image').css('background-image', 'url('+post.image+')')
                .end()
                .find('.blogpost-caption').html(post.title)
                .end()
                .find('.blogpost-category').html(post.category)
                .end()
                .find('.blogpost-excerpt').html('<span class="date grey">'+post.date+'</span> '+post.excerpt);
              $postList.append($newPost);
            });
          } else {
            $load.fadeOut();
          }

          // Remove duplicate posts
          exclude_ids = $('.blogpost').collectIds();
          compressed = compressArray(exclude_ids);
          _.each(compressed, function(compressed, index, list) {
            if (compressed.count > 1)  {
              var $post = $('.blogpost[data-id="'+compressed.value+'"]');
              if ($post.length > 1) {
                var seen = {};
                $post.each(function() {
                    var txt = $(this).text();
                    if (seen[txt])
                      $(this).remove();
                    else
                      seen[txt] = true;
                });
              }
            }
          });

          // Remove loading dots, when done loading
          $load.html($load.html().replace(/\./g, ''));

          // After loading posts adjust again the height of the post list
          s.enforceRowHeights();

          // Update pagination indexes
          start += loadPerClick;
        }
      });

    });
  };


  // /**
  // * Ensures that image within a blogpost are not wider than the main body of
  // * the post. It enforces the width to the image to its parent <a> element
  // * and its (or the <a>'s') parent .caption element.
  // */
  // var enforceImagesWidth = function enforceImagesWidth () {
  //   var maxWidth = $('.wordpress-body').width();
  //
  //   $('.wordpress-body img').each(function() {
  //     var cssWidth = Math.floor(maxWidth) + 'px';
  //     var $this = $(this);
  //
  //     if ($this.width() > maxWidth) {
  //       var $parent = $this.parent();
  //
  //       $this.css('width', cssWidth);
  //
  //       if ($parent.prop('tagName') === 'A') {
  //         $parent.css('width', cssWidth);
  //
  //         if ($parent.parent().hasClass('caption')) {
  //             $parent.parent().css('width', cssWidth);
  //         }
  //       } else if ($parent.hasClass('caption')) {
  //         $parent.css('width', cssWidth);
  //       }
  //     }
  //   });
  // };


  /**
  * A hackish way to correct styles from wordpress' wysiwyg.
  */
  var correctBlogpostDetailStyles = function correctBlogpostDetailStyles() {
    $('p > img.alignleft, p > img.alignright,' +
      'p > a > img.alignleft, p > a > img.alignright').each(function(){

      $(this).closest('p').css({
        paddingBottom: 0,
        marginBottom: 0
      });

    });
  };


  var checkForBlogPages = function checkForBlogPages() {
    if (s.bodyId === 'body-blogpost-list') {
      setupSelectSubmit();
      setupLoadMore();
    } else if (s.bodyId === 'body-blogpost-detail') {
      correctBlogpostDetailStyles();
    }
  };


  s.callOnReady(checkForBlogPages);

})(jQuery, this, this.document, window.s);
